import AUTH_ROLES, { AuthRoles } from '@marketmuse/config/types/authRoles';

function checkIsOrgAdmin(orgRole?: AuthRoles | string | null) {
  return orgRole === AUTH_ROLES.ADMIN || orgRole === AUTH_ROLES.MM_CX_ADMIN;
}

export default checkIsOrgAdmin;
